// extracted by mini-css-extract-plugin
export default {"rankingTag":"RankingTag_rankingTag__9SpV3","rankingIcon":"RankingTag_rankingIcon__7l9ZM","rankingLink":"RankingTag_rankingLink__ZBvvp","underline":"RankingTag_underline__pGUqg"};